import { ChangeDetectionStrategy, Component, signal } from "@angular/core";
import { OfferAdvertiserUrlParams } from "../../../models/offers/offer-advertiser-url-params";

@Component({
    selector: "app-offer-advertiser-url-params-tooltip",
    standalone: true,
    imports: [],
    templateUrl: "./offer-advertiser-url-params-tooltip.component.html",
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OfferAdvertiserUrlParamsTooltipComponent {
    public params = signal(OfferAdvertiserUrlParams);
}
